/**
 * 时间：2022年8月4日 16点36分
 * 说明：该文件用于存放所有模块所使用 config 的常量
 */
// 环境
export const ENV = process.env.NANO_ENV;

// 开发环境
export const DEV = "dev" === ENV;

// 生产环境
export const PROD = "prod" === ENV;

// 请求基础接口
export const BASE_API = process.env.NANO_BASE_API;

// 对象存储地址
export const OSS_URL = process.env.NANO_OSS_URL;

// 应用上下文
export const APP_CONTEXT = process.env.NANO_APP_CONTEXT;

// 应用更新时间
export const APP_UPDATE_TIME = process.env.NANO_APP_UPDATE_TIME;

// 项目名称
export const PROJECT_NAME = process.env.NANO_PROJECT_NAME;
